
import { Component, Vue } from 'vue-property-decorator';
import { getSimpleNew } from '@/api/statistics';
import { iSelectOptionsList } from '@/interface/cancel-detail';
import ShortcutDate from '@/components/shortcutdate/shortcutdate.vue';
@Component({
  components: { ShortcutDate },
})
export default class UserGeneralView extends Vue {
  private dataDefault: Date = new Date();
  detail: Array<any> = [];
  private start!: any;
  private end!: any;
  public dates: (string | Date)[] = [];
  private pickerBeginDateBefore: { disabledDate: Function } = {
    disabledDate(time: any) {
      return time.getTime() > Date.now() - 3600 * 1000 * 24;
    },
  };
  private initDay: string | number = 1;
  private initSort = 0;
  loading: boolean = false;
  sort_by: number = 1;
  totalInfo = {};
  defaultDays: { day: number; initDay: number } = { day: 7, initDay: 1 }; // 默认近7天
  //快捷日期:
  private shortcutDays: iSelectOptionsList[] = [
    { label: '昨日', value: 1 },
    { label: '近7天', value: 7 },
    { label: '近15天', value: 15 },
    { label: '近30天', value: 30 },
    { label: '统计数据不包含当天', value: 0 },
  ];
  params: { page: number; page_size: number } = {
    page: 1,
    page_size: 10,
  };
  total: number = 0;
  getShortcutTimeFn(dates: (string | Date)[], params: { start: number; end: number }, activeIndex: number) {
    this.initDay = activeIndex;
    this.dates = dates;
    this.start = params.start;
    this.end = params.end;
    this.params.page = 1;
    this.getSimpleTable();
  }
  dateHandler(datavalue: Date[]) {
    this.initDay = '';
    this.start = Math.floor(datavalue[0].getTime() / 1000);
    this.end = Math.floor(datavalue[1].getTime() / 1000) + 3600 * 24 - 1;
    // this.page = 1;
    this.getSimpleTable();
  }
  handleSizeChange(page_size: number) {
    this.params.page = 1;
    this.params.page_size = page_size;
    this.getSimpleTable();
  }
  handleCurrentChange(page: number) {
    this.params.page = page;
    this.getSimpleTable();
  }
  async getSimpleTable() {
    this.loading = true;
    try {
      const res = await getSimpleNew({ start: this.start, end: this.end, ...this.params });
      if (res && res.code == 0) {
        this.totalInfo = res.data.total;
        this.detail = res.data.detail.list;
        this.total = res.data.detail.total;
      }
      this.loading = false;
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
  }
}
